import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchOutreachByIdInBackground } from '@/store/outreach/actions';
import { fetchBlueprintByIdInBackground } from '@/store/blueprint/actions';

const getOutreachStepById = async ({ stepId }, { extra: { http } }) => {
  try {
    const result = await http.get(`/steps/${stepId}`);
    return result;
  } catch (e) {}
};

const onCreateStep = async (payload, { extra: { http } }) => {
  try {
    const {
      stepName,
      interval,
      templateId,
      id,
      senderId,
      templateSubject,
      templateBody,
      newThread,
    } = payload;
    const params = {
      step_interval: interval,
      name: stepName,
      outreach_id: id,
      sender_id: senderId,
      new_thread: newThread,
    };
    if (templateId) {
      params.template_id = templateId;
    } else {
      params.template_subject = templateSubject;
      params.template_body = templateBody;
    }
    const result = await http.post('/steps', { step: params });
    return result;
  } catch (e) {}
};

const onUpdateStep = async (payload, { extra: { http } }) => {
  try {
    const {
      stepName,
      interval,
      templateId,
      id,
      senderId,
      templateSubject,
      templateBody,
      stepId,
      newThread,
    } = payload;
    const params = {
      step_interval: interval,
      name: stepName,
      outreach_id: id,
      sender_id: senderId,
      new_thread: newThread,
    };

    if (templateId) {
      params.template_id = templateId;
    } else {
      params.template_subject = templateSubject;
      params.template_body = templateBody;
    }
    const result = await http.put(`/steps/${stepId}`, {
      step: params,
    });
    return result;
  } catch (e) {}
};

const onDeleteStep = async (
  { stepId, outreachId, blueprintId },
  { extra: { http }, dispatch }
) => {
  try {
    const result = await http.delete(`/steps/${stepId}`);

    if (result?.errors?.length !== 0) return;
    if (!blueprintId) {
      dispatch(fetchOutreachByIdInBackground({ outreachId }));
      return;
    }
    dispatch(
      fetchBlueprintByIdInBackground({ blueprint: { id: blueprintId } })
    );
    return result;
  } catch {}
};

const onArchiveStep = async (
  { stepId, outreachId, blueprintId },
  { extra: { http }, dispatch }
) => {
  try {
    const result = await http.put(`/steps/${stepId}/archive`);
    if (result?.errors?.length !== 0) return;
    if (!blueprintId) {
      dispatch(fetchOutreachByIdInBackground({ outreachId }));
      return;
    }
    dispatch(
      fetchBlueprintByIdInBackground({ blueprint: { id: blueprintId } })
    );

    return result;
  } catch {}
};

export const fetchStepById = createAsyncThunk(
  'step/fetch/byId',
  getOutreachStepById
);

export const createOutreachStep = createAsyncThunk(
  'outreach/step/create',
  onCreateStep
);
export const updateOutreachStep = createAsyncThunk(
  'outreach/step/update',
  onUpdateStep
);

export const deleteOutreachStep = createAsyncThunk(
  'outreach/step/delete',
  onDeleteStep
);

export const archiveOutreachStep = createAsyncThunk(
  'outreach/archive',
  onArchiveStep
);
